import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { onClose } from "src/app/shared/interfaces";
import { CreateExamInterface, ExamInterface } from "src/app/shared/interfaces/settings/exam";

export const examActions = createActionGroup({
    source: "exam",
    events: {
        "load exams": emptyProps(),
        "set exams": props<{ data: ExamInterface[] }>(),
        create: props<{
            data: CreateExamInterface;
            onClose: onClose;
        }>(),
        update: props<{
            data: CreateExamInterface;
            id: string;
            onClose: onClose;
        }>(),
    },
});
